module.exports = __webpack_public_path__ + "img/police_car.bb36f10e.jpg";